import { StringHash } from '@app/shared/utils/utils-types';
import { SimpleTopic } from '../../../origami-api/utils/topic-utils';
import { BaseSettingsGroup } from './setting-group-base';
import { ConfigServiceOptions } from '../../../origami-api/services/config.service';
import ModuleName = ConfigServiceOptions.ModuleName;
import { SettingsStore } from './settings-store';
import { Observable, of } from 'rxjs';

export abstract class BaseSettingsModule extends BaseSettingsGroup<SettingsStore, SimpleTopic> {
  constructor(
    public moduleName: ModuleName,
    mainStore: SettingsStore,
    defaultStore: SettingsStore,
    saveTopic: (topic: SimpleTopic) => Observable<boolean>,
  ) {
    super(mainStore, defaultStore, saveTopic);

    if (!mainStore[moduleName]) {
      mainStore[moduleName] = {};
    }
  }

  abstract getValues(): StringHash<any>;
  abstract getDbValues(returnOnlyDirty: boolean): SimpleTopic;

  save(): Observable<boolean> {
    const topic = this.getDbValues(true);
    return topic ? this.saveData(topic) : of(false);
  }
}
